import React from "react";
import { Avatar } from "@mui/material";
import { FiDollarSign } from "react-icons/fi";
import { GoDownload, GoPeople } from "react-icons/go";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import useCommission from "./hooks/useCommission";
import { useEffect } from "react";
import { GiBackwardTime } from "react-icons/gi";

const BroupCommissionDetails = () => {
  const navigate = useNavigate();
  const { data, method } = useCommission();
  const { commGroupDetailsList } = data;
  const { commissionDetails, handleDownloadGroupDetails } = method;

  const { GROUP_ID } = useParams();

  useEffect(() => {
    if (GROUP_ID) {
      commissionDetails(GROUP_ID);
    }
  }, [GROUP_ID]);
 
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  const StatusBadge = ({ status }) => {
    if (!status) return "-";

    const isActive = status.toLowerCase() === "active";

    return (
      <span
        style={{
          padding: "4px 12px",
          borderRadius: "999px",
          fontSize: "12px",
          fontWeight: 500,
          backgroundColor: isActive ? "#E6FAF0" : "#FDECEC",
          color: isActive ? "#16A34A" : "#DC2626",
          display: "inline-block",
          minWidth: "70px",
          textAlign: "center",
        }}
      >
        {status}
      </span>
    );
  };

   const currencySymbol = "₹";

  return (
    <section>
      <ToastContainer />
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <div className="d-flex justify-content-between">
            <div>
              <h2 className="page-tittle mb-0">
                <i
                  className="fa-solid fa-angle-left cusgap cursor"
                  onClick={() => navigate(-1)}
                />
                {commGroupDetailsList?.header?.groupName}
              </h2>
              <span style={{ fontSize: "12px", paddingLeft: "18px" }}>
                Member History & Performanced
              </span>
            </div>

            <button onClick={()=>handleDownloadGroupDetails(GROUP_ID)}
              className="btn px-4"
              style={{
                background: "linear-gradient(to right, #EA8F80, #F09A8B)",
                color: "#FFF",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                paddingBlock: "10px",
              }}
            >
              <GoDownload fontSize={18} style={{ marginRight: "6px" }} />
              Download Report
            </button>
          </div>
          <hr />
        </header>
        <div>
          <div>
            {/* Top Summary Cards */}
            <div className="row g-3 mb-4 align-items-stretch">
              <div className="col-md-4">
                <div className="shadow-sm p-3 h-100 d-flex align-items-center rounded-3">
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      <small className="text-muted">Total Earned</small>
                      <h4 className="mb-0">
                      {currencySymbol}{commGroupDetailsList?.summary?.totalEarned}
                      </h4>
                    </div>
                    <FiDollarSign fontSize={18} color="#00DE71" />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="shadow-sm p-3 h-100 d-flex align-items-center rounded-3">
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      <small className="text-muted">Current Members</small>
                      <h4 className="mb-0">
                        {commGroupDetailsList?.summary?.currentMembers}
                      </h4>
                    </div>
                    <GoPeople fontSize={18} color="#CC8DFF" />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="shadow-sm p-3 h-100 d-flex align-items-center rounded-3">
                  <div className="d-flex justify-content-between w-100">
                    <div className="d-flex flex-column">
                      <small className="text-muted">
                        Total Members (All Time)
                      </small>
                      <h4 className="mb-0">
                        {commGroupDetailsList?.summary?.totalMembers}
                      </h4>
                    </div>
                     <GiBackwardTime fontSize={18} color="#EA8F80" />
                  </div>
                </div>
              </div>
            </div>

            {/* Member Card */}
            {commGroupDetailsList?.members?.map((items) => (
              <div key={items?.staffId} className="shadow-sm mb-4">
                <div className="d-flex align-items-center gap-1 my-4 px-2 pt-4">
                  <GiBackwardTime fontSize={20} color="#EA8F80" />
                  <h6 className="mb-0">Member History</h6>
                </div>

                {/* Table */}
                <div className="table-responsive">
                  <table className="table">
                    <thead className="table-light">
                      <tr>
                        <th>Member Name</th>
                        <th>Join Date</th>
                        <th>Leave Date</th>
                        <th>Duration</th>
                        <th>Sale Volume</th>
                        <th>Total Earned</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr key={items?.staffId}>
                        <td style={{ textAlign: "left" }}>
                          <span className="d-flex align-items-center gap-2">
                            <Avatar
                              alt="Remy Sharp"
                              src="/static/images/avatar/1.jpg"
                            />
                            <span>{items?.memberName || "-"}</span>
                          </span>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          {formatDate(items?.joinDate) || "-"}
                        </td>
                        <td
                          className="text-success"
                          style={{ textAlign: "left" }}
                        >
                          {formatDate(items?.leaveDate) || "-"}
                        </td>
                        <td
                          className="text-success"
                          style={{ textAlign: "left" }}
                        >
                          {items?.durationMonths || "-"}
                        </td>
                        <td
                          className="text-success"
                          style={{ textAlign: "left" }}
                        >
                          {items?.salesVolume || "-"}
                        </td>
                        <td
                          className="text-success"
                          style={{ textAlign: "left" }}
                        >
                          {items?.totalEarned || "-"}
                        </td>
                        <td
                          className="text-success"
                          style={{ textAlign: "left" }}
                        >
                          <StatusBadge status={items?.status} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BroupCommissionDetails;
